import { render, staticRenderFns } from "./UnSuspendApproval.vue?vue&type=template&id=02860612&scoped=true"
import script from "./UnSuspendApproval.vue?vue&type=script&lang=js"
export * from "./UnSuspendApproval.vue?vue&type=script&lang=js"
import style0 from "./UnSuspendApproval.vue?vue&type=style&index=0&id=02860612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02860612",
  null
  
)

export default component.exports